export enum DeviceStatus {
  Hidden = 0,
  PortalAndWebsite = 1,
  PortalOnly = 2,
}
